import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../lib/shared/validators";

export const roleType = v.union(
  v.literal("super_admin"),
  v.literal("company_admin"),
  v.literal("company_user"),
);

export const validatorRole = v.object({
  name: v.string(),
  description: v.string(),
  type: roleType,
  internalControl,
});

export const roles = defineTable(validatorRole)
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_company_and_type", ["internalControl.companyId", "type"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_state", ["internalControl.state"])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_branch_and_state", [
    "internalControl.branchId",
    "internalControl.state",
  ])
  .index("by_created_by", ["internalControl.createdBy"])
  .index("by_updated_by", ["internalControl.updatedBy"])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ]);
